import Team7 from './Team7'
export default Team7
